import React, { Component } from "react";

class LandingPageVvvebBuilder extends Component {

  componentDidMount() {
    document.querySelector(".pc-header")?.style.setProperty("display", "none");
    document.querySelector(".pc-footer")?.style.setProperty("display", "none");
    document.querySelector(".pc-sidebar")?.style.setProperty("display", "none");
  }

  componentWillUnmount() {
    document.querySelector(".pc-header")?.style.setProperty("display", "block");
    document.querySelector(".pc-footer")?.style.setProperty("display", "block");
    document.querySelector(".pc-sidebar")?.style.setProperty("display", "block");
  }

  render() {
    const height = this.props.height || "100vh";

    const path = window.location.pathname;
    const segments = path.split("/").filter(Boolean);
    const landing_id = [...segments].reverse().find(seg => /^\d+$/.test(seg));

    return (
      <div style={{ width: "100%", height }}>
        <iframe
          title="VvvebJs Editor"
          src={`/vvvebjs/editor.html?landing_id=${landing_id}`}
          style={{
            width: "100%",
            height: "100%",
            border: "0",
            minHeight: "600px"
          }}
        />
      </div>
    );
  }
}

export default LandingPageVvvebBuilder;
